import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { AppSettingsLoaderService } from '@core/services/common/app-settings-loader.service';
import { of } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@NgModule({})
export class ConfiguratorModule {
  static forRoot(): ModuleWithProviders<ConfiguratorModule> {
    return {
      ngModule: ConfiguratorModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: (loadSettings: AppSettingsLoaderService) => {
            return () => {
              if (environment.isLocalWeb) {
                loadSettings.initConfig();

                return loadSettings.currentConfig$
                  .pipe(
                    take(1),
                    tap((config) => {
                      loadSettings.setConfig(config);
                    }),
                  )
                  .toPromise();
              }

              return of(false);
            };
          },
          multi: true,
          deps: [AppSettingsLoaderService],
        },
      ],
    };
  }
}
